import { render, staticRenderFns } from "./AttachmentRequestContinueDialog.vue?vue&type=template&id=8070ceba&scoped=true&"
import script from "./AttachmentRequestContinueDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachmentRequestContinueDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentRequestContinueDialog.vue?vue&type=style&index=0&id=8070ceba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8070ceba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
